import Q from 'q';

import type { ActionContext } from 'js/lib/ActionContext';
import user from 'js/lib/user';

import S12nStoreClass from 'bundles/in-course-stores/stores/S12nStore';
import s12nOwnershipPromise from 'bundles/s12n-common/service/promises/s12nOwnershipPromiseFactory';
import { rawPrimaryS12ns } from 'bundles/s12n-common/service/promises/s12ns';

export default (actionContext: ActionContext, courseId: string): Q.Promise<any> => {
  if (actionContext.getStore(S12nStoreClass).hasLoaded()) {
    return Q();
  }

  let rawS12ns: $TSFixMe;

  return rawPrimaryS12ns(courseId, user.get().id)
    .then((loadedRawS12ns: $TSFixMe) => {
      rawS12ns = loadedRawS12ns;
      const rawS12nsList = rawS12ns.elements;

      const rawS12n = rawS12nsList && rawS12nsList[0];
      if (rawS12n && user.isAuthenticatedUser()) {
        return s12nOwnershipPromise(rawS12n.id, true);
      } else {
        return Q();
      }
    })
    .then((rawOwnership: $TSFixMe) => {
      actionContext.dispatch('LOAD_S12N', { rawS12ns, rawOwnership });
      return { rawS12ns, rawOwnership };
    });
};
